module.exports = __webpack_public_path__ + "static/media/crow_going_to_river.b8d0bee2.gif";